import axios from "axios";

const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

const fetchDistinctDetails = async (payload, serviceId) => {
    let res = await axios.put(process.env.REACT_APP_DOCDB_SERVICE_URL + "/" + serviceId + "/nq-customer-project-designer-mappings", payload, getAuthHeaders()).catch(() => {
        return [];
    });
    return res.data;
};

const fetchCustomerDesignerDetails = async (payload) => {
    let res = await axios.post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/getCustomerDesignerDetails/", payload, getAuthHeaders()).catch(() => {
        return [];
    });
    return res.data;
};

const fetchUserDetails = async (payload = {}) => {
    let res = await axios.post(process.env.REACT_APP_DOCDB_SERVICE_URL + "/imaginehome_master_db/nq-userpermissions", payload, getAuthHeaders()).catch(() => {
        return [];
    });
    return res.data;
};


const fetchUserDetailsWithToken = async (payload = {}, token) => {
    let res = await axios.post(process.env.REACT_APP_DOCDB_SERVICE_URL + "/imaginehome_master_db/nq-userpermissions", payload, {
        headers: { Authorization: `Bearer ${token}` }
    }).catch(() => {
        return [];
    });
    return res.data;
};

const fetchProjectFiles = async (payload) => {
    let res = await axios.post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/list", payload, getAuthHeaders()).catch((e) => {
        return [];
    });
    return res.data;
};

const fetchProjectFilesNew = async (payload) => {
    let res = await axios.post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/v1/list", payload, getAuthHeaders()).catch((e) => {
        return [];
    });
    return res.data;
};

const uploadRoomFile = async (payload) => {
    let res = await axios.post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/upload/", payload, getAuthHeaders()).catch((err) => {
        throw err;
    });
    return res.data;
};

const uploadRoomFileNew = async (payload) => {
    let res = await axios.post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/v1/upload/", payload, getAuthHeaders()).catch((err) => {
        throw err;
    });
    return res.data;
};

const fetchMaster = async (col, serviceId, payload = {}) => {
    let res = await axios.post(process.env.REACT_APP_DOCDB_SERVICE_URL + "/" + serviceId + "/" + col, payload, getAuthHeaders()).catch(() => {
        return [];
    });
    return res.data;
};

const fetchDownloadFileUrl = async (payload) => {
    let res = await axios.post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/downloadURL", payload, getAuthHeaders()).catch(() => {
        return {};
    });
    return res.data;
};

const assignDesigner = async (paylaod = {}) => {
    let res = await axios.post(process.env.REACT_APP_DOCDB_SERVICE_URL + "/config/assign-cust-to-designer", paylaod, getAuthHeaders()).catch(() => {
        return [];
    });
    return res.data;
};

const saveInvoiceData = async (payload) => {
    let res = await axios.post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/getLineItems/", payload, getAuthHeaders()).catch(() => {
        return {};
    });
    return res.data;
};

const uploadQuoteFile = async (payload) => {
    let res = await axios.post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/LLMdocDataExtraction/", payload, getAuthHeaders()).catch(() => {
        return {};
    });
    return res.data;
};
const createOrder = async (payload) => {
    let res = await axios.post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/orderCreation/", payload, getAuthHeaders()).catch(() => {
        return {};
    });
    return res.data;
};

const saveRoomFiles = async (Formdata, files) => {
    const cloneFormData = (formData) => {
        const newFormData = new FormData();
        for (let [key, value] of formData.entries()) {
            newFormData.append(key, value);
        }
        return newFormData;
    };
    let successRes = 0;
    const fileUploaded = [];
    const values = [];
    if (files.length > 0) {
        const promiseArr = [];
        for (let i = 0; i < files.length; i++) {
            let formdata = cloneFormData(Formdata);
            formdata.set("file", files[i]);
            fileUploaded.push(files[i].name);
            promiseArr.push(uploadRoomFileNew(formdata));
        }
        let res = await Promise.allSettled(promiseArr).catch((err) => console.error(err));
        if (res) {
            res.forEach((item, index) => {
                if (item.status === "rejected") {
                    fileUploaded.splice(index, 1);
                } else {
                    successRes++;
                    values.push(item.value);
                }
            });
        }
    }
    return { successRes, fileUploaded, values };
};
const uploadSKUMedia = async (payload, onUploadProgress) => {
    let res = await axios
        .post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/uploadSKUMedia/", payload, {
            onUploadProgress,
            ...getAuthHeaders(),
        })
        .catch((err) => {
            throw err;
        });
    return res;
};
const fetchProductCatalogues = async (payload) => {
    let res = await axios.post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/listProductCatalogue/", payload, getAuthHeaders()).catch(() => {
        return [];
    });
    return res.data;
};
const downloadMultipleMediaURL = async (payload) => {
    let res = await axios.post(process.env.REACT_APP_API_PARSER_URL + "/imaginehomes/downloadURL_multiple/", payload, getAuthHeaders()).catch(() => {
        return [];
    });
    return res.data;
};
const fetchGalleryImages = async (serviceId) => {
    let res = await axios.post(`${process.env.REACT_APP_API_PARSER_URL}/imaginehomes/getHomePageImages?serviceId=${serviceId}`, null, getAuthHeaders()).catch(() => {
        return [];
    });
    return res.data;
};
const uploadGalleryImages = async (payload) => {
    let res = await axios.post(`${process.env.REACT_APP_API_PARSER_URL}/imaginehomes/uploadImages`, payload, getAuthHeaders()).catch(() => {
        return [];
    });
    return res.data;
};
const editGalleryImageMetaData = async (payload) => {
    let res = await axios
        .post(`${process.env.REACT_APP_API_PARSER_URL}/imaginehomes/editImageMetadata`, null, {
            params: payload,
            ...getAuthHeaders(),
        })
        .catch(() => {
            return [];
        });
    return res.data;
};
const deleteGalleryImages = async (payload) => {
    let res = await axios.post(`${process.env.REACT_APP_API_PARSER_URL}/imaginehomes/deleteImages`, payload, getAuthHeaders()).catch(() => {
        return [];
    });
    return res.data;
};

const addCompanyOrgnizationInformation = async (payload) => {
    let res = await axios
        .post(`${process.env.REACT_APP_TENANT_SERVICE_URL}/create-org`, payload, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        })
        .catch(() => {
            return [];
        });
    return res.data;
};
const updateTradePartnerInformation = async (payload) => {
    let res = await axios
        .patch(`${process.env.REACT_APP_TENANT_SERVICE_URL}/update-org`, payload, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        })
        .catch(() => {
            return [];
        });
    return res.data;
};
const getSingleTradePartnerInformation = async (payload) => {
    let res = await axios
        .post(`${process.env.REACT_APP_TENANT_SERVICE_URL}/get-org`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        })
        .catch(() => {
            return [];
        });
    return res.data;
};
const getTradePartnerListsData = async (payload) => {
    let res = await axios
        .post(`${process.env.REACT_APP_TENANT_SERVICE_URL}/get-orgs`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        })
        .catch(() => {
            return [];
        });
    return res.data;
};
const getSuppliersReportsData = async (payload) => {
    try {
        const res = await axios.post(
            `${process.env.REACT_APP_TENANT_SERVICE_URL}/get-suppliers`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            }
        );
        if (res?.data?.responseCode === 200) {
            return res.data.responseData;
        }
        return [];
    } catch (err) {
        console.error("Failed to fetch supplier reports:", err);
        return [];
    }
};

const service = {
    assignDesigner,
    fetchDistinctDetails,
    fetchUserDetails,
    fetchUserDetailsWithToken,
    fetchProjectFiles,
    uploadRoomFile,
    fetchMaster,
    fetchDownloadFileUrl,
    saveInvoiceData,
    saveRoomFiles,
    uploadSKUMedia,
    fetchProductCatalogues,
    downloadMultipleMediaURL,
    uploadQuoteFile,
    fetchGalleryImages,
    uploadGalleryImages,
    editGalleryImageMetaData,
    deleteGalleryImages,
    addCompanyOrgnizationInformation,
    getTradePartnerListsData,
    updateTradePartnerInformation,
    getSingleTradePartnerInformation,
    fetchCustomerDesignerDetails,
    createOrder,
    getSuppliersReportsData,
    fetchProjectFilesNew
};
export default service;
